import { Observable } from "rxjs";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { IProviderBranches } from "../models/warranties/provider-branches.interface";
import { Provider } from "../models/warranties/provide-res.interface";
import { HttpParamsUtil } from "../utils/http-params.util";
import { Inject, Injectable } from "@angular/core";
import { RetryHttpClient } from "./base/retryable-http.client";

@Injectable({
  providedIn: "root",
})
export class ProviderService extends HttpParamsUtil {
  constructor(
    private readonly httpClient: RetryHttpClient,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {
    super();
  }

  getProviderGE(): Observable<Provider[]> {
    return this.httpClient.get<Provider[]>(`${this.environment.BASE_URL}${this.environment.PROVIDER["BASE"]}/ge`);
  }

  getProviderGC(): Observable<Provider[]> {
    return this.httpClient.get<Provider[]>(`${this.environment.BASE_URL}${this.environment.PROVIDER["BASE"]}/gc`);
  }

  getProviders(sku: string, subclass: string): Observable<IProviderBranches[]> {
    const params = {
      sku,
      subclass,
    };
    const httpParams = this.toHttpParams(params);
    return this.httpClient.get<IProviderBranches[]>(`${this.environment.BASE_URL}${this.environment.PROVIDER["BASE"]}/branches`, {
      params: httpParams,
    });
  }
}
